<!--
 * @Author: your name
 * @Date: 2021-04-01 10:18:41
 * @LastEditTime: 2021-06-12 17:05:21
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \exclusive-cloud-admin\common\src\components\page-header\page-header.vue
-->
<template>
	<div class="page-info-header">
		<div class="page-info-header-label flex-align-center">
			<efly-tooltip content="返回" top="34px" left="-15px" placement="bottom" type="white" style="display:inline-block;" v-if="$parent.Mixin_isBack || isBack" >
				<efly-button class="page-info-header-back-btn btn-primary" @click="back()">
					<i class="icon icon-goback"></i>
				</efly-button>
			</efly-tooltip>
			<i class="icon color-primary" :class="titleIcon" v-else></i>
			<span class="mar-l-mini text-color-regular">{{title}}</span>
			<span class="font-default text-secondary" v-show="describe" v-html="describe"></span>
		</div>
<!--		<div class="page-info-header-guidance text-color-regular" @click="skip()" v-if="doc">-->
<!--			<i class="icon" :class="docIcon"></i>-->
<!--			{{doc}}-->
<!--		</div>-->
	</div>
</template>

<script>
    import PageHeader from "./page-header";
    export default PageHeader;
</script>

<style lang="scss" scoped>
</style>
